"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataScrubber = void 0;
var lodash_clonedeepwith_1 = __importDefault(require("lodash.clonedeepwith"));
var DataScrubber = /** @class */ (function () {
    function DataScrubber(config) {
        var _this = this;
        /**
         * Process current node
         *
         * @private
         */
        this.processNode = function (value, key) {
            if (value instanceof Error) {
                var clonedError = new (Object.getPrototypeOf(value).constructor)(value.message);
                Object.assign(clonedError, (0, lodash_clonedeepwith_1.default)(__assign({}, Object(value)), _this.processNode)); // Apply handlers to properties
                return clonedError;
            }
            return _this.applyHandlers(value, key);
        };
        this.applyHandlers = function (value, key) {
            var handlers = _this.config.getRuleConfigs(key);
            if (handlers.length) {
                return handlers.reduce(function (acc, ruleItem) {
                    acc = ruleItem.handler(acc, ruleItem.options);
                    return acc;
                }, value);
            }
            return undefined;
        };
        this.config = config;
    }
    /**
     * Scrub sensitive data
     */
    DataScrubber.prototype.scrub = function (data) {
        if (data !== Object(data)) {
            return data;
        }
        return (0, lodash_clonedeepwith_1.default)(data, this.processNode);
    };
    return DataScrubber;
}());
exports.DataScrubber = DataScrubber;
//# sourceMappingURL=DataScrubber.js.map